module.exports = __webpack_public_path__ + "img/FI19043879.918ebcc0.png";